export const isEmpty = (val: any) => {
  if (val === undefined || val === null || !val) {
    return true
  } else {
    if (Array.isArray(val) && val.length < 1) {
      return true
    }
      
    if (typeof val === 'object' && Object.keys(val).length < 1) {
      return true
    }
  }
  
  return false
}

export const obj2strStyle = (obj: {[key: string]: any}) => {
  let style = ''
  
  for (let key in obj) {
    const val: string = obj[key]
    style += `${key}:${val};`
  }
  
  return style
}

export const getStaticImg = (imgName: string, { ext, folderPath }: any) => {
  const baseUrl = '/assets/img'
  const extStr = ext ? ext : 'png'

  return folderPath ? `${baseUrl}/${folderPath}/${imgName}.${extStr}` : `${baseUrl}/${imgName}.${extStr}`
}
